import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import * as tablerIcons from '@ng-icons/tabler-icons';
import * as tablerIconsFill from '@ng-icons/tabler-icons/fill';
import { provideIcons } from '@ng-icons/core';
import { LayoutStoreService } from '@core/services/layout-store.service';
import { ExitGuardService } from '@core/services/exit-guard.service';
import { SharedModule } from '@shared/shared-module';
import { ExitType } from '@core/guards/exit-interface';
import { ScrollDisableService } from '@core/services/scroll-disable.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, SharedModule],
  templateUrl: './app.html',
  viewProviders: [provideIcons({...tablerIcons, ...tablerIconsFill})]
})
export class App implements OnInit {
    @ViewChild('lockExitModal', { static: true }) lockExitModal!: TemplateRef<any>;
    @ViewChild('activeModificationExitModal', { static: true }) activeModificationExitModal!: TemplateRef<any>;

    layout = inject(LayoutStoreService); // Required for theme params

    constructor(
        private exitGuardService: ExitGuardService,
        private scrollDisableService: ScrollDisableService,
    ) {
    }

    ngOnInit() {
        this.layout.setIsLoading(false);
        this.exitGuardService.registerTemplate(ExitType.LOCK, this.lockExitModal);
        this.exitGuardService.registerTemplate(ExitType.ACTIVE_MODIFICATION, this.activeModificationExitModal);
    }
}
